
const handymans = require("./images/for_handymans.PNG");
const GetHandyman = () => {
  return (
    <section className="pb-14 mt-10">
      <div className="max-w-screen-xl mx-auto px-4 text-gray-600 gap-x-12 items-start justify-between lg:flex md:px-8 mt-8">
        <div className="sm:hidden lg:block lg:max-w-xl">
          <img
            fetchpriority="low"
            src={handymans}
            className="rounded-lg shadow-2xl"
            alt="Bacome a handyman"
          />
        </div>
        <div className="mt-6 gap-12 sm:mt-0 md:flex lg:block">
          <div className="max-w-2xl">
            <h3 className="text-gray-800 text-3xl font-semibold sm:text-4xl">
            Are you a skilled handyman? Get hired on-demand!
            </h3>
            <p className="mt-3 max-w-xl">
              Look no further! By joining our platform, you can easily get
              access to potential clients and get hired on-demand. Our platform
              connects you with individuals in need of handyman services in your
              local area, offering you the opportunity to grow your business and
              increase your income. Getting started is simple. Just fill out the
              form and wait for your account created.
            </p>
            <p className="font-bold text-lg my-5">
              Your next job is just a few clicks away!
            </p>

            <a href="/handyman">
              <button className="px-20 py-4 text-white font-bold text-lg duration-150 bg-sky-600 rounded-full hover:bg-sky-500 active:bg-sky-700">
                Get hired
              </button>
            </a>
          </div>
          
        </div>
      </div>
    </section>
)};

export default GetHandyman;
